<script>
    import CylVol from "./CylVol.svelte";
    import RectVol from "./RectVol.svelte";
    import { Styles } from "sveltestrap";
    import { TabContent, TabPane, Icon, Card, CardBody } from "sveltestrap";
    import CylinderIcon from "./Shapes/CylinderIcon.svelte";
    import CubeIcon from "./Shapes/CubeIcon.svelte";

    $: cylStroke = iconColour("cyl", activeTab);
    $: cubStroke = iconColour("rect", activeTab);
    $: activeTab = "rect";

    function iconColour(tab, icon) {
        if (tab === "cyl" && icon === "cyl") return "#000000";
        if (tab === "cyl" && icon === "rect") return "#0d6efd";
        if (tab === "rect" && icon === "rect") return "#000000";
        if (tab === "rect" && icon === "cyl") return "#0d6efd";
    }
</script>

<Styles />

<Card>
    <CardBody>
        <TabContent on:tab={(e) => (activeTab = e.detail)}>
            <TabPane tabId="rect" active>
                <span slot="tab">
                    Cube <div class="icon"><CubeIcon stroke={cubStroke} /></div>
                </span>
                <br />
                <RectVol />
            </TabPane>
            <TabPane tabId="cyl">
                <span slot="tab">
                    Cylinder <div class="icon">
                        <CylinderIcon stroke={cylStroke} />
                    </div>
                </span>
                <br />
                <CylVol />
            </TabPane>
        </TabContent>
    </CardBody>
</Card>

<style>
    .icon {
        margin-left: 0.5rem;
        display: inline-block;
    }
</style>
